<template>
  <IconLucideRows2 />
</template>
